/**
 * 锁定 / 频控的「还要等多久」文案（剩余秒数见 ApiError.retryAfterSeconds / retryWaitSeconds：
 * data.retry_after_seconds > Retry-After > locked_until − serverNow()）。
 * 只接收 t，不依赖组件上下文：API 拦截器与组件共用。
 */
import { waitDuration } from '~/utils/time'

type Translate = (key: string, ...args: unknown[]) => string

/** 等待时长文案：1 小时 58 分 / 58 分钟 / 2 小时；不足 1 分钟或未知返回 null（改说「稍后再试」） */
export function formatWaitText(t: Translate, seconds: number | null): string | null {
  if (seconds === null) return null
  const d = waitDuration(seconds)
  if (!d) return null
  if (d.hours && d.minutes) return t('common.time.waitHm', { h: d.hours, m: d.minutes })
  if (d.hours) return t('common.time.waitH', { h: d.hours })
  return t('common.time.waitM', { m: d.minutes })
}

/**
 * 资金密码锁定（1030）提示：「资金密码连续输错 5 次，已锁定，请 1 小时 58 分后再试」；
 * 不足 1 分钟或取不到剩余时间：「……已锁定，请稍后再试」。
 * （「连续输错 5 次将锁定 2 小时」这类规则说明是政策描述，另有文案，不走这里。）
 */
export function fundLockedMessage(t: Translate, seconds: number | null): string {
  const wait = formatWaitText(t, seconds)
  return wait ? t('payout.errFundLocked', { wait }) : t('payout.errFundLockedSoon')
}
